"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenLinking = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ModalComponent_1 = require("@CommonFrontend/Modal/ModalComponent");
var ChangeTemplateHeading_1 = require("Project/Actions/Tokens/ChangeTemplateHeading/ChangeTemplateHeading");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons = __importStar(require("@qwilr/kaleidoscope/icons"));
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var UseAutomationsMetadata_1 = require("Library/AutomationLibrary/hooks/UseAutomationsMetadata");
var AutomationsApiService_1 = require("Library/AutomationLibrary/AutomationsApiService");
exports.TokenLinking = (0, mobx_react_1.observer)(function (props) {
    var closeModal = props.closeModal, tokenReplacementStore = props.tokenReplacementStore, tokenIntegrations = props.tokenIntegrations, currentProviderType = props.currentProviderType, currentCrmObjectType = props.currentCrmObjectType, openTokenReplacementModal = props.openTokenReplacementModal;
    var _a = __read((0, react_1.useState)(tokenReplacementStore.crmObjectType), 2), initialObject = _a[0], setInitialObject = _a[1];
    var automationsMetadata = (0, UseAutomationsMetadata_1.useAutomationsMetadata)();
    var update = (0, AutomationsApiService_1.useAssociations)().update;
    var _b = __read((0, react_1.useState)(false), 2), isAutomationTemplate = _b[0], setIsAutomationTemplate = _b[1];
    (0, react_1.useEffect)(function () {
        tokenReplacementStore.getCurrentSubstitutionTokensFromTemplate();
    }, []);
    (0, react_1.useEffect)(function () {
        if (automationsMetadata.data) {
            automationsMetadata.data.forEach(function (metadata) {
                if (metadata.integrationName !== tokenReplacementStore.providerType) {
                    setIsAutomationTemplate(false);
                    return;
                }
                metadata.supportedObjects.forEach(function (object) {
                    if (object.name === initialObject) {
                        setIsAutomationTemplate(true);
                    }
                });
            });
        }
    }, [automationsMetadata]);
    var labelPipedriveObject = function (object) {
        switch (object) {
            case "Persons":
                return "People (Contacts)";
            case "Organizations":
                return "Organizations (Contacts)";
        }
        return object;
    };
    var renderToggles = function () {
        return tokenIntegrations.integrations.map(function (_a) {
            var _b;
            var name = _a.name, displayName = _a.displayName, supportedObjects = _a.supportedObjects, icon = _a.icon;
            var Icon = (icon && icons[icon]) || icons.Tokens;
            return (react_1.default.createElement("div", { key: name, className: "token-linking__option" },
                react_1.default.createElement("div", { className: "token-linking__provider-info" },
                    react_1.default.createElement(Icon, { className: "token-linking__provider-icon", size: icons.IconSize.Large }),
                    react_1.default.createElement(kaleidoscope_2.Toggle, { value: tokenReplacementStore.providerType === name, label: "Use in ".concat(displayName), onChange: function () { return updateProviderType(name); } })),
                tokenReplacementStore.providerType === name && (react_1.default.createElement(kaleidoscope_1.RadioButtonGroup, { selectedId: (_b = tokenReplacementStore.crmObjectType) !== null && _b !== void 0 ? _b : undefined, options: supportedObjects.map(function (object) {
                        return {
                            id: object,
                            label: tokenReplacementStore.providerType === Types_1.ProviderType.Pipedrive
                                ? labelPipedriveObject(object)
                                : object,
                            disabled: false,
                        };
                    }), onClickHandler: updateCrmObjectType }))));
        });
    };
    var shouldDisableTokenLinking = function () {
        var providerType = tokenReplacementStore.providerType, crmObjectType = tokenReplacementStore.crmObjectType, hasFinishedFetchingCurrentSubstitutionTokens = tokenReplacementStore.hasFinishedFetchingCurrentSubstitutionTokens;
        return (!providerType ||
            !crmObjectType ||
            !hasFinishedFetchingCurrentSubstitutionTokens ||
            (providerType === currentProviderType && crmObjectType === currentCrmObjectType));
    };
    var updateProviderType = function (providerType) {
        if (tokenReplacementStore.providerType === providerType) {
            tokenReplacementStore.setProviderType(null);
            return;
        }
        tokenReplacementStore.setProviderType(providerType);
        tokenReplacementStore.setCrmObject(null);
    };
    var updateCrmObjectType = function (crmObjectType) {
        tokenReplacementStore.setCrmObject(crmObjectType);
    };
    var onConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isAutomationTemplate && initialObject !== tokenReplacementStore.crmObjectType)) return [3, 2];
                    return [4, update(tokenReplacementStore.projectId, [], "template")];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!!tokenReplacementStore.hasTokens) return [3, 4];
                    return [4, tokenReplacementStore.replaceTokens()];
                case 3:
                    _a.sent();
                    closeModal();
                    return [2];
                case 4: return [4, tokenReplacementStore.searchTokens()];
                case 5:
                    _a.sent();
                    openTokenReplacementModal();
                    return [2, true];
            }
        });
    }); };
    var handleConfirmCallback = function (callbackValue) {
        if (!callbackValue) {
            closeModal();
        }
    };
    return (react_1.default.createElement("div", { className: "token-linking" },
        react_1.default.createElement(ChangeTemplateHeading_1.ChangeTemplateHeading, { title: "Change template type", subtitle: "This will change where your template appears in your CRM, as well as what tokens will be available to use.", alert: tokenReplacementStore.hasProductTokens
                ? "If you have product line items in your quote, they will be removed when changing the template type."
                : undefined }),
        isAutomationTemplate && (react_1.default.createElement(kaleidoscope_1.Stack, { paddingBottom: "m" },
            react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Warning" }, "Changing the template type will un-assign all automations from this template."))),
        react_1.default.createElement("div", { className: "token-linking__content" }, renderToggles()),
        react_1.default.createElement(ModalComponent_1.ConfirmModalButtons, { callback: handleConfirmCallback, confirming: onConfirm, confirmLabel: tokenReplacementStore.hasTokens ? "Continue " : "Confirm", disableConfirmButton: shouldDisableTokenLinking() })));
});
